import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/sync-master/list',
    method: 'get',
    params: data
  })
}

export function syncData(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/sync-master/sync-data',
    method: 'post',
    data: data
  })
}


export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/sync-master/create',
    method: 'post',
    data: data
  })
}






// WEBPACK FOOTER //
// ./src/api/sync_master.js